const mainColor = '#b91c1c'
export const light = {
  // ... 사용자 정의 theme code
  color: {
    mainColor: mainColor,
    mainColorOpacity20: mainColor+'3d',
    mainColorOpacity5: mainColor+'12',
    bgColor: '#f8f8f8',
    subColor: '#ccc',
    topicColor: '#f5811f',
    textColor: '#222',
    reverseTextColor: '#aaaaaa',
    borderColor: '#e5e5e5',
    lightGray: '#ddd',
    linkColor: '#0088ff',
    whiteColor: '#ffffff'
  }
}
